import { createApp as _createApp } from "virtual:astro:app";
const createApp = _createApp;
export {
  createApp
};
